import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    showFooter: false,
    transitionName: ""
  },
  mutations: {
    showFooter: function showFooter(state, value) {
      if (value) {
        setTimeout(function () {
          state.showFooter = value;
        }, 1000);
      } else {
        state.showFooter = value;
      }
    },
    setTransitionName: function setTransitionName(state, value) {
      state.transitionName = value;
    }
  },
  actions: {},
  modules: {}
});